import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { Router, RouterModule } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'lib-category-tag',
  template: `
    @if ({ row: columnData | async, adata: additionData | async }; as $) {
      <a class="cursor-pointer" (click)="onGoToRoute($.adata?.uri, $.row, coerceBoolean($.adata?.canRedirect))"
        [pTooltip]="getTooltip($.row)" tooltipStyleClass="text-xs" aria-label="category-link">
        <p-tag [value]="getLabel($.row) | translate"
        severity="info" />
      </a>
    }
    `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TagModule, TranslateModule, RouterModule, TooltipModule, AsyncPipe]
})
export class CategoryTagComponent {
  private router = inject(Router);

  columnData: Observable<any> = new BehaviorSubject<any>(null);
  additionData: Observable<any> = new BehaviorSubject<any>(null);

  getLabel(row: any): string {
    const cat = (row?.category || '').toString().toUpperCase();
    return (cat ? ('COMMISSION_MANAGEMENT.CATEGORIES.' + cat) : '') as any;
  }

  getTooltip(row: any): string {
    return row?.category || '';
  }

  coerceBoolean(v: any): boolean {
    if (typeof v === 'boolean') return v;
    if (typeof v === 'string') return v === 'true';
    return true;
  }

  onGoToRoute(uriTemplate: string, row: any, canRedirect = true) {
    if (!canRedirect || !uriTemplate) return;
    const url = this.buildUrlFromTemplate(uriTemplate, row);
    if (url) this.router.navigate([url]);
  }

  private buildUrlFromTemplate(template: string, row: any): string {
    return template.replace(/:([a-zA-Z0-9_]+)/g, (_m, p1) => {
      const candidates = [p1, this.toSnake(p1), this.toCamel(p1), this.aliasFor(p1)];
      for (const c of candidates) {
        const val = row?.[c];
        if (val !== undefined && val !== null) return String(val);
      }
      return '';
    });
  }

  private toSnake(s: string): string { return s.replace(/[A-Z]/g, m => '_' + m.toLowerCase()); }
  private toCamel(s: string): string { return s.replace(/_([a-z])/g, (_m, c) => c.toUpperCase()); }
  private aliasFor(key: string): string {
    switch (key) {
      case 'id': return 'id';
      case 'planId': return 'plan_id';
      case 'ruleId': return 'rule_id';
      default: return key;
    }
  }
}


